/**
 * Validates a phone number based on its country code.
 *
 * @param {string} phone - National phone number (digits only or raw string)
 * @param {string|number} countryCode - Country dial code without plus (e.g., '91', '1', '971')
 * @param {boolean} isRequired - Whether the phone number is mandatory
 * @returns {{ isValid: boolean, message?: string }}
 */
export const validatePhoneNumber = (phone, countryCode = '91', isRequired = true) => {
  const cleanPhone = phone ? String(phone).replace(/\D/g, '') : '';
  const cleanCountryCode = countryCode ? String(countryCode).replace(/^\+/, '').trim() : '91';

  if (!cleanPhone) {
    if (isRequired) {
      return { isValid: false, message: 'Phone number is required' };
    }
    return { isValid: true };
  }

  if (cleanCountryCode === '91') {
    // India: exactly 10 digits
    if (cleanPhone.length !== 10) {
      return { isValid: false, message: 'Phone number must be 10 digits for India (+91)' };
    }
  } else if (cleanCountryCode === '1') {
    // US / Canada: exactly 10 digits
    if (cleanPhone.length !== 10) {
      return { isValid: false, message: 'Phone number must be 10 digits for US/Canada (+1)' };
    }
  } else if (cleanCountryCode === '971') {
    // UAE: exactly 9 digits
    if (cleanPhone.length !== 9) {
      return { isValid: false, message: 'Phone number must be 9 digits for UAE (+971)' };
    }
  } else if (cleanCountryCode === '44') {
    // UK: 10 or 11 digits
    if (cleanPhone.length < 10 || cleanPhone.length > 11) {
      return { isValid: false, message: 'Phone number must be 10 or 11 digits for UK (+44)' };
    }
  } else if (cleanCountryCode === '65') {
    // Singapore: 8 digits
    if (cleanPhone.length !== 8) {
      return { isValid: false, message: 'Phone number must be 8 digits for Singapore (+65)' };
    }
  } else if (cleanCountryCode === '61') {
    // Australia: 9 digits
    if (cleanPhone.length !== 9) {
      return { isValid: false, message: 'Phone number must be 9 digits for Australia (+61)' };
    }
  } else {
    // International standard (ITU-T E.164): between 7 and 15 digits
    if (cleanPhone.length < 7 || cleanPhone.length > 15) {
      return { isValid: false, message: 'Phone number must be between 7 and 15 digits' };
    }
  }

  return { isValid: true };
};
